var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 82,
  height: 54,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M63.5 20.25V4.5C63.5 2.025 61.475 0 59 0H5A4.513 4.513 0 0 0 .5 4.5v45C.5 51.975 2.525 54 5 54h54c2.475 0 4.5-2.025 4.5-4.5V33.75l18 18V2.25l-18 18Z",
  fill: "#C2CBD8"
})));
export { SvgVideoLarge as ReactComponent };
export default __webpack_public_path__ + "images/video_large.svg";